import { IInfo } from "src/component/props/PropsGGEditor/exec/ExecScript";
import UIManifest from "src/engine/ui/UIManifest";
import Http from "src/lib/http/Http";
import { CONTENT_TYPE, METHOD } from "src/lib/http/HttpEmun";
import Script from "src/component/script/Script";

interface IExitJJScript {
    redirectUrl?: string  // 退出成功后，重定向路径
}


@UIManifest.declare("ExitJJScript", "退出JJ账号", UIManifest.Type.Script)
class ExitJJScript extends Script<IExitJJScript>{
    exec(info: IInfo, callback: (info: IInfo) => any) {
        const { redirectUrl } = this.props;
        Http.ajax({
            url: `https://jj.cn/user/logout.php?loginout=js&ck_type=design&t=${Math.random()}`,
            method: METHOD.GET,
            dataType: CONTENT_TYPE.JSONP
        }).then(() => {
            console.log("退出成功");
            if (redirectUrl)
                window.location.href = redirectUrl;
            callback({ ...info })
        }).catch((e) => {
            console.log("退出失败:", e);
        })
        return true;
    }
}

export default ExitJJScript;